<h2 mat-dialog-title class="av-section-title">{{ data.title | translate }}</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0" data-testid="confirm-consequence">{{ data.consequence | translate }}</p>

  <dl class="d-flex flex-column gap-2 m-0">
    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.common.reason_dialog.organization' | translate }}</dt>
      <dd class="m-0 cell-strong text-end" data-testid="confirm-organization">
        {{ data.organizationName }}
      </dd>
    </div>

    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.subscriptions.confirm.amount_label' | translate }}</dt>
      <dd class="m-0 text-end" data-testid="confirm-amount">{{ data.amountLabel | translate }}</dd>
    </div>
  </dl>

  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    @if (hasModes) {
      <label class="d-flex flex-column gap-1" for="confirm-mode">
        <span class="av-meta">{{ 'backoffice.subscriptions.confirm.mode' | translate }}</span>
        <select id="confirm-mode" class="av-field" formControlName="mode">
          @for (mode of data.modes; track mode) {
            <option [value]="mode">{{ data.modeLabels[mode] | translate }}</option>
          }
        </select>
      </label>

      <p class="av-meta m-0" data-testid="confirm-mode-consequence">{{ modeConsequence() | translate }}</p>
    }

    @if (data.isCommitmentLocked) {
      <div class="av-banner p-3 d-flex align-items-start gap-2" data-testid="commitment-lock-banner">
        <mat-icon aria-hidden="true">lock</mat-icon>
        <span>{{ 'backoffice.subscriptions.commitment.locked' | translate }}</span>
      </div>

      @if (data.canOverrideCommitment) {
        <label class="d-flex align-items-center gap-2" for="confirm-override">
          <input
            id="confirm-override"
            type="checkbox"
            formControlName="override_commitment_lock"
            data-testid="commitment-override-toggle"
          />
          <span>{{ 'backoffice.subscriptions.commitment.override_label' | translate }}</span>
        </label>

        @if (wantsOverride()) {
          <label class="d-flex flex-column gap-1" for="confirm-override-reason">
            <span class="av-meta">{{ 'backoffice.subscriptions.commitment.override_reason_label' | translate }}</span>
            <textarea
              id="confirm-override-reason"
              class="av-field"
              rows="2"
              [attr.maxlength]="reasonMax"
              formControlName="override_reason"
              data-testid="commitment-override-reason"
            ></textarea>
          </label>
        }
      }
    }

    <label class="d-flex flex-column gap-1" for="confirm-reason">
      <span class="av-meta">{{ 'backoffice.licences.reason' | translate }}</span>
      <textarea
        id="confirm-reason"
        class="av-field"
        rows="3"
        [attr.maxlength]="reasonMax"
        formControlName="reason"
        data-testid="confirm-reason"
      ></textarea>
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="dismiss()">{{ 'backoffice.common.actions.cancel' | translate }}</button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!formGroup.valid || !isSubmittable()"
    (click)="confirm()"
    data-testid="confirm-submit"
  >
    {{ data.confirmLabel | translate }}
  </button>
</mat-dialog-actions>
